import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.3816 6.19928L11.998 0.811035L3.61776 6.19957L4.69946 7.88181L4.99973 7.68873V11.1057L1.625 13.168L2.6679 14.8746L2.99973 14.6718V21.9998H11V16H13V21.9998H20.9997V14.6718L21.3316 14.8746L22.3745 13.168L18.9997 11.1057V7.68857L19.3003 7.88175L20.3816 6.19928ZM6.99973 9.88345V6.40272L11.9982 3.18865L16.9997 6.40316V9.88345L11.9997 6.8279L6.99973 9.88345Z"}}]};

const Building5Filled = Vue.extend<IconProps>({
  name: 'Building5FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'building-5-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Building5Filled;
